import dynamic from 'next/dynamic'
import classNames from 'classnames'
import Translations from '@helpers/translations'
import OptionWithIcon, {
  OptionWithIconProps
} from '@components/ui/FitOption/OptionWithIcon'
import { BuildOptionValue } from '../types'
import styles from './styles.module.scss'

const BUILD_DESCRIPTION = {
  A: Translations.localise('product.filters.build-a-desc'),
  B: Translations.localise('product.filters.build-b-desc'),
  C: Translations.localise('product.filters.build-c-desc')
} as const

type Icons = Record<string, React.ComponentType<React.SVGProps<SVGElement>>>
const icons: Icons = {
  buildA: dynamic(
    () =>
      import('@svgs/illustration/build-a.svg').then(
        importedComponent => importedComponent.ReactComponent
      ),
    {
      ssr: false
    }
  ),
  buildB: dynamic(
    () =>
      import('@svgs/illustration/build-b.svg').then(
        importedComponent => importedComponent.ReactComponent
      ),
    {
      ssr: false
    }
  ),
  buildC: dynamic(
    () =>
      import('@svgs/illustration/build-c.svg').then(
        importedComponent => importedComponent.ReactComponent
      ),
    {
      ssr: false
    }
  )
}

type OptionValue = BuildOptionValue | (string & NonNullable<unknown>)

export type BuildOptionProps = Omit<
  OptionWithIconProps<OptionValue>,
  'icon' | 'description'
>
function BuildOption(props: BuildOptionProps) {
  const icon = icons[`build${props.optionValue}`]

  const iconClasses = classNames({
    [styles.BuildIcon_disabled]: !props.active,
    [styles.BuildIcon_active]: props.active,
    [styles.BuildIcon_selected]: props.selected
  })

  const description =
    props.optionValue in BUILD_DESCRIPTION
      ? BUILD_DESCRIPTION[props.optionValue as keyof typeof BUILD_DESCRIPTION]
      : ''

  return (
    <OptionWithIcon<OptionValue>
      {...props}
      icon={icon}
      description={description}
      iconClasses={iconClasses}
    />
  )
}

export default BuildOption
